module.exports = __webpack_public_path__ + "img/5C.1816ea05.jpg";